import { AssetId } from "./asset-id";

/**
 * An asset that has been initialized but not yet fully installed.
 *
 * This represents the early lifecycle stage where an asset has been identified
 * by the fleet system but has not yet been associated with a tenant and site.
 *
 * Compared to `InstalledAsset`:
 * - `InitializedAsset` only has asset identity (pre-installation)
 * - `InstalledAsset` has tenant, site, and asset (post-installation)
 *
 * The asset must be fleet-sourced since initialization occurs within the fleet system.
 */
export type InitializedAsset = {
  asset: AssetId<"fleet">;
};
